import { subscribeVoiceSocketEvent } from '../../infrastructure/socket/initializeVoiceSocket';
import { VOICE_SOCKET_EVENTS } from '../../domain/voiceEventConstants';
import incomingCallHandler from './incomingCallHandler';
import agentSipInviteHandler from './agentSipInviteHandler';
import callAnsweredHandler from './callAnsweredHandler';
import callHangupHandler from './callHangupHandler';
import callFailedHandler from './callFailedHandler';

export default function subscribeVoiceCallEvents(ports) {
  return [
    subscribeVoiceSocketEvent(
      VOICE_SOCKET_EVENTS.INCOMING_CALL,
      (payload) => incomingCallHandler(payload, ports)
    ),
    subscribeVoiceSocketEvent(
      VOICE_SOCKET_EVENTS.AGENT_SIP_INVITE,
      (payload) => agentSipInviteHandler(payload, ports)
    ),
    subscribeVoiceSocketEvent(
      VOICE_SOCKET_EVENTS.CALL_ANSWERED,
      (payload) => callAnsweredHandler(payload, ports)
    ),
    subscribeVoiceSocketEvent(
      VOICE_SOCKET_EVENTS.CALL_HANGUP,
      (payload) => callHangupHandler(payload, ports)
    ),
    subscribeVoiceSocketEvent(
      VOICE_SOCKET_EVENTS.CALL_FAILED,
      (payload) => callFailedHandler(payload, ports)
    )
  ];
}
